<!--选择excle文件并上传页面-->
<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin: 20px;text-align: right;font-weight: bold;font-size:16px;margin-right: 30px;cursor: pointer;"
          @click="backToHome()">
          <返回 </div>


            <div
              style="padding: 10px;display: flex;justify-content: center;flex-direction: column;align-items: center;">
              <div>
                <div style="text-align: center;margin: 5px;font-size:22px;">简易自评表</div>
                <div style="text-align: center;margin: 5px;font-size:16px;color:red;">(更多设置请用微信小程序操作)</div>
              </div>
              <div style="width: 70%;padding:40px;border: 1px solid lightgray;">
                <div style="margin-left: 20px;margin-top: 20px;">
                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分表名称：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
                    </div>
                    <div>
                      <input v-model="form_name" placeholder="输入打分表名称" style="width: 400px;;" />
                    </div>
                  </div>


                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分范围：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
                    </div>
                    <div style="font-size: 14px;">
                      最低分：<el-input-number v-model="min_value"></el-input-number>~最高分： <el-input-number
                        v-model="max_value"></el-input-number>
                    </div>
                  </div>

                  <div style="margin-bottom: 30px;">
                    <div
                      style="font-size: 16px;font-weight: bold;margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;">
                      <span>
                        自评人名单：<span style="color:red;font-size: 16x;font-weight: bold;vertical-align: middle;">*</span>
                      </span>
                      <span>
                        <span style="font-weight: bold;text-decoration: underline;cursor: pointer;margin-right: 40px;"
                          @click="importExcelUsers">导入Excel文件中名单</span>
                        <span style="font-weight: bold;text-decoration: underline;cursor: pointer;"
                          @click="importScoreUsers">导入预存名单</span>
                      </span>
                    </div>
                    <div>
                      <textarea v-model="score_user_content" maxlength="-1" rows="10" style="width: 100%;"></textarea>
                    </div>
                  </div>



<!--                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      <el-checkbox-group v-model="forbid_decimal_checked_state" @change="forbidDecimalChange">
                        <el-checkbox :label="1"><span
                            style="font-size: 16px;font-weight: bold;">打分不允许出现小数</span></el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div> -->

                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      咨询电话：
                    </div>
                    <div>
                      <input v-model="contact_phone" placeholder="打分咨询电话" style="width: 400px;;" />
                    </div>
                  </div>


                  <div style="margin-bottom: 30px;">
                    <div style="font-size: 16px;font-weight: bold;margin-bottom: 10px;">
                      打分注意事项：
                    </div>
                    <div>
                      <textarea v-model="form_comment" maxlength="-1" rows="10" style="width: 100%;"></textarea>
                    </div>
                  </div>

                </div>


              </div>

              <div style="display: flex;justify-content: center;margin-top: 10px;margin-bottom: 40px;">

                <el-button size="medium" type="primary" style="width: 400px;" @click="saveForm()">立即保存</el-button>
              </div>

            </div>
      </el-col>
    </el-row>

    <!--导入预设名单-->
    <el-dialog title="导入预设名单" :close-on-click-modal="false" :visible.sync="importScoreUserGroupDialogVisible"
      width="40%">
      <div>
        <div style="margin-top: 10px;">
          <div>
            <el-select @change="selectGroup" v-model="seleced_group" placeholder="请选择">
              <el-option v-for="item in groups" :key="item.group_name" :label="item.group_name"
                :value="item.group_name">
              </el-option>
            </el-select>
          </div>

          <div style="margin-top: 20px;">
            <el-input type="textarea" rows="10" placeholder="请输入内容" v-model="selected_user_names" />
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="importScoreUserGroupDialogVisible = false">取消</el-button>
        <el-button @click="insertScoreUsers()" type="primary">导入名单</el-button>
      </div>

    </el-dialog>



  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        form_id: '',
        form_name: '',
        min_value: 0,
        max_value: 100,
        score_user_content: '',
        form_comment: '',
        contact_phone: '',

        importScoreUserGroupDialogVisible: false,
        groups: [],
        seleced_group: '',
        selected_user_names: '',


        forbid_decimal: '0',
        forbid_decimal_checked_state: false
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.form_id = this.$route.params.form_id


      if (!Utils.isEmpty(this.form_id)) {
        this.loadSelfScoreForm()
      }

      this.loadGroups() //导入用户

    },
    methods: {
      forbidDecimalChange() {
        // console.log(this.forbid_decimal)
        if (this.forbid_decimal_checked_state == true) {
          this.forbid_decimal = '1'
        } else {
          this.forbid_decimal = '0'
        }

        console.log(this.forbid_decimal)
      },
      loadGroups() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_load_user_groups.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username
            }
          }).then(function(response) {
            that.groups = response.data.user_group_list

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      selectGroup(e) {
        console.log(e)
        // this.selected_user_names=e

        for (var i = 0; i < this.groups.length; i++) {
          var gName = this.groups[i].group_name

          if (gName == e) {
            this.selected_user_names = this.groups[i].name_str
            break
          }
        }
      },
      insertScoreUsers() {
        this.score_user_content = this.selected_user_names
        this.importScoreUserGroupDialogVisible = false
      },
      importScoreUsers() {
        this.importScoreUserGroupDialogVisible = true
      },

      buildNameArray(content_str) {
        var tmpNameStr = content_str.trim()

        let tmpList = []
        let names = []

        tmpList = tmpNameStr.split(/[\n]/)


        var tStr = ''

        for (var i = 0; i < tmpList.length; i++) {
          if (!Utils.isEmpty(tmpList[i])) {
            var str = tmpList[i]
            str = str.trim()

            names.push(str)
          }
        }

        return names
      },
      saveForm() {
        if (Utils.isEmpty(this.form_name)) {
          this.$message.error('请输入打分表名称!')
          return
        }
        if (Utils.isEmpty(this.score_user_content)) {
          this.$message.error('请输入自评人员名单!')
          return
        }



        let that = this

        var qs = require('qs')



        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var score_quota_name = '自评得分'
        var tmpArray = this.distinct(this.buildNameArray(this.score_user_content))
        var score_users_json_str = JSON.stringify(tmpArray)

        let data = {
          form_id:that.form_id,
          form_name: that.form_name,
          form_comment: that.form_comment,
          score_users: score_users_json_str,
          // start_time: that.start_time,
          // end_time: that.end_time,
          contact_phone: that.contact_phone,
          equipment: that.username,
          score_quota_name: score_quota_name,
          min_value: that.min_value,
          max_value: that.max_value,
          forbid_decimal: that.forbid_decimal
        }

        var requestUrl = '/evaluations/web/_save_self_single_quota_form.jsp'
        this.axios.post(requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            load.close()
            that.$message('保存成功')

            that.$router.push('/form_list')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      backToHome() {
        this.$router.go(-1)
      },
      importExcelUsers() {
        this.$alert('打开Excel文件，复制姓名列，直接粘贴到下面的框中即可。', '导入Excel中的姓名', {
          confirmButtonText: '知道了',
          callback: action => {}
        });
      },
      distinct(list) {
        let result = [list[0]]; // 用于承接没有重复的数据，初始时将原始数组的第一个值赋给它。
        for (let i = 1; i < list.length; i++) {
          // 判断结果数组中是否存在一样的值，若果没有的话则将数据存入结果数组中。
          if (!(result.some(val => list[i] === val))) {
            result.push(list[i]);
          }
        }
        return result;
      },
      loadSelfScoreForm() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_load_self_score_form.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id
            }
          }).then(function(resp) {

            load.close()

            if (resp.data.result == '1') {
              that.form_name = resp.data.form.form_name
              that.contact_phone = resp.data.form.contact_phone
              that.form_comment = resp.data.form.form_comment
              that.min_value=resp.data.score_field.min_value
              that.max_value=resp.data.score_field.max_value

              //自评人
              var tmpScoreUsers = resp.data.score_users
              var tmpScoreUserContent = ''
              for (var i = 0; i < tmpScoreUsers.length; i++) {
                if (i == 0) {
                  tmpScoreUserContent = tmpScoreUsers[i].score_user
                } else {
                  tmpScoreUserContent = tmpScoreUserContent + '\n' + tmpScoreUsers[i].score_user
                }
              }

              that.score_user_content = tmpScoreUserContent
            }


          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      }


    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  .uploadFileStyle {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/self_score_form_creater.vue